export type MetaPixelQueue = {
  (...args: any[]): void;
  callMethod?: (...args: any[]) => void;
  queue?: IArguments[];
  push?: MetaPixelQueue;
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: MetaPixelQueue;
    _fbq?: MetaPixelQueue;
  }
}

const META_PIXEL_SCRIPT_ID = "meta-pixel-script";
const META_PIXEL_SCRIPT_SRC = "https://connect.facebook.net/en_US/fbevents.js";

const configuredMetaPixelIds = new Set<string>();

const createMetaPixelQueue = (): MetaPixelQueue => {
  const fbq = function () {
    if (fbq.callMethod) {
      fbq.callMethod.apply(fbq, arguments as any);
      return;
    }

    fbq.queue = fbq.queue || [];
    fbq.queue.push(arguments);
  } as MetaPixelQueue;

  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.queue = [];

  return fbq;
};

const hasMetaPixelScript = (): boolean =>
  !!document.getElementById(META_PIXEL_SCRIPT_ID) ||
  !!document.querySelector(`script[src="${META_PIXEL_SCRIPT_SRC}"]`);

const insertMetaPixelScript = () => {
  if (hasMetaPixelScript()) {
    return;
  }

  const script = document.createElement("script");
  script.id = META_PIXEL_SCRIPT_ID;
  script.async = true;
  script.src = META_PIXEL_SCRIPT_SRC;

  const firstScript = document.getElementsByTagName("script")[0];

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
    return;
  }

  document.head.appendChild(script);
};

export const configureMetaPixel = (pixelId: string) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  if (!pixelId) {
    return;
  }

  window.fbq = window.fbq || createMetaPixelQueue();
  window._fbq = window._fbq || window.fbq;
  insertMetaPixelScript();

  if (configuredMetaPixelIds.has(pixelId)) {
    return;
  }

  configuredMetaPixelIds.add(pixelId);
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
};

export const resetMetaPixelForTests = () => {
  configuredMetaPixelIds.clear();
};
